import React, { useState, useEffect } from 'react';
import EmployeeResignation from './EmployeeResignation';
import OffboardingDashboard from './OffboardingDashboard';

const Offboarding = () => {
    const [userRole, setUserRole] = useState(null);
    const [user, setUser] = useState(null);
    const [view, setView] = useState('DASHBOARD'); // 'DASHBOARD' or 'PERSONAL'

    useEffect(() => {
        const storedUser = JSON.parse(localStorage.getItem('zTaskUserDetails') || '{}');
        const role = (storedUser.role?.name || storedUser.role || 'EMPLOYEE').toUpperCase();

        if (['ADMIN', 'HR', 'SUPER_ADMIN'].includes(role)) {
            setUserRole('HR');
        } else {
            setUserRole('EMPLOYEE');
            setView('PERSONAL');
        }
        setUser(storedUser);
    }, []);

    if (!userRole) {
        return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', color: '#64748B' }}>Loading...</div>;
    }

    return (
        <div className="offboarding-container">
            {userRole === 'HR' && (
                <div className="view-toggle-wrap">
                    <div className="view-toggle-container">
                        <button
                            onClick={() => setView('DASHBOARD')}
                            className={`toggle-btn ${view === 'DASHBOARD' ? 'active' : ''}`}
                        >
                            Management View
                        </button>
                        <button
                            onClick={() => setView('PERSONAL')}
                            className={`toggle-btn ${view === 'PERSONAL' ? 'active' : ''}`}
                        >
                            My Resignation
                        </button>
                    </div>
                </div>
            )}

            {view === 'DASHBOARD' ? (
                <OffboardingDashboard />
            ) : (
                <EmployeeResignation user={user} />
            )}
        </div>
    );
};

export default Offboarding;
